import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, LoadingController } from 'ionic-angular';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { AuthenticationApi } from '../../services/authentication/authentication-api';
import { LoginPage } from '../login/login';

@IonicPage({
  name: "reset",
  segment: "reset/:token"
})
@Component({
  selector: 'page-reset-password',
  templateUrl: 'reset-password.html',
})
export class ResetPasswordPage {
  private token: string;
  public resetPasswordForm: FormGroup;
  public email: FormControl;
  public password_confirmation: FormControl;
  public password: FormControl;
  public completed: Boolean = false;

  ionViewCanEnter() {
    let self: ResetPasswordPage = this;
    return new Promise((resolve, reject) => {
      self.storage.getItem("reset-password-email")
        .subscribe(res => {
          self.email.setValue(res);
          resolve(null);
        },
        rej => {
          resolve(null);
        });
    });
  }

  reset(credentials: FormGroup) {
    let request: any = credentials;
    let self: ResetPasswordPage = this;

    let loading = this.loadingCtrl.create({ content: 'Sending Email...' });
    loading.present();

    request.token = this.token;
    this.authApi.reset(request)
      .subscribe(
        res => {
          self.completed = true;
          loading.dismiss();
          let toast = self.toastCtrl.create({message: res.message, duration: 7000, position: "top", closeButtonText: "Ok", dismissOnPageChange: true});
          toast.present();
          self.storage.removeItem("reset-password-email")
            .subscribe(() => {
              self.storage.setItem("login-email",request.email)
                .subscribe(() => {
                  setTimeout(function(){
                    self.home();
                  },4000);
                })
            })
        },
        rej => {
          loading.dismiss();
          let toast = self.toastCtrl.create({message: rej.message, duration: 7000, position: "top", closeButtonText: "Ok", dismissOnPageChange: true});
          toast.present();
        }
      );
  }

  home() {
    this.navCtrl.push(LoginPage);
  }

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private fb: FormBuilder,
    private authApi: AuthenticationApi,
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController,
    private storage: AsyncLocalStorage) {

      this.token = this.navParams.get("token");

      this.email = this.fb.control('', Validators.compose([Validators.required]));
      this.password = this.fb.control('', Validators.compose([Validators.required]));
      this.password_confirmation = this.fb.control('', Validators.compose([Validators.required]));
      this.resetPasswordForm = this.fb.group({
        email: this.email,
        password: this.password,
        password_confirmation: this.password_confirmation
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/reset-password/reset-password.ts